import 'babel-polyfill';
import 'raf/polyfill';
import 'react-hot-loader';
import { create } from 'jss';
import { JssProvider } from 'react-jss';
import { MuiThemeProvider } from '@material-ui/core/styles';
import { render } from 'react-dom';
import createGenerateClassName from '@material-ui/core/styles/createGenerateClassName';
import preset from 'jss-preset-default';
import React from 'react';

import 'react-table/react-table.css';
import { activateLogger } from './Shared/UIEventLogger/UIEventLogger';
import { lightTheme } from './Shared/Themes';
import configureStore from './Root/RootStore/configureStore';
import RootContainer from './Root/RootContainer';

const jss = create(preset());
jss.options.createGenerateClassName = createGenerateClassName;

activateLogger();

const rootEl = document.getElementById('root');

render(
  <JssProvider jss={jss}>
    <MuiThemeProvider theme={lightTheme}>
      <RootContainer store={configureStore} />
    </MuiThemeProvider>
  </JssProvider>,
  rootEl
);



// WEBPACK FOOTER //
// ./src/index.js